module.exports = __webpack_public_path__ + "img/RS.d71d14f9.svg";